import { IPayRate, IPayrateAttachment } from "../../types/payrates/PayRate";
import RatesApi, {
  IClonePayrateRequest,
  ICreateAssociationPayrateAttachmentRequest,
  ICreateAssociationPayrateRequest
} from "../api/ratesApi";
import * as types from "./actionTypes";

// Existing action creators
function getPayrateByIdStarted() {
  return { type: types.PAYRATES_GET_BY_ID_STARTED };
}
function getPayrateByIdFulfilled(payrate: IPayRate) {
  return { type: types.PAYRATES_GET_BY_ID_FULFILLED, payload: payrate };
}
function getPayrateByIdRejected(error: Error) {
  return {
    type: types.PAYRATES_GET_BY_ID_REJECTED,
    payload: { message: error.message, stack: error.stack },
  };
}

function getAllPayratesStarted() {
  return { type: types.PAYRATES_GET_ALL_STARTED };
}
function getAllPayratesFulfilled(payrates: IPayRate[]) {
  return { type: types.PAYRATES_GET_ALL_FULFILLED, payload: payrates };
}
function getAllPayratesRejected(error: Error) {
  return {
    type: types.PAYRATES_GET_ALL_REJECTED,
    payload: { message: error.message, stack: error.stack },
  };
}

// New association payrate action creators
function createAssociationPayrateStarted() {
  return { type: types.PAYRATES_CREATE_ASSOCIATION_STARTED };
}
function createAssociationPayrateFulfilled(payrate: IPayRate) {
  return { type: types.PAYRATES_CREATE_ASSOCIATION_FULFILLED, payload: payrate };
}
function createAssociationPayrateRejected(error: Error) {
  return {
    type: types.PAYRATES_CREATE_ASSOCIATION_REJECTED,
    payload: { message: error.message, stack: error.stack },
  };
}

function updateAssociationPayrateStarted() {
  return { type: types.PAYRATES_UPDATE_ASSOCIATION_STARTED };
}
function updateAssociationPayrateFulfilled(payrate: IPayRate) {
  return { type: types.PAYRATES_UPDATE_ASSOCIATION_FULFILLED, payload: payrate };
}
function updateAssociationPayrateRejected(error: Error) {
  return {
    type: types.PAYRATES_UPDATE_ASSOCIATION_REJECTED,
    payload: { message: error.message, stack: error.stack },
  };
}

function deleteAssociationPayrateStarted() {
  return { type: types.PAYRATES_DELETE_ASSOCIATION_STARTED };
}
function deleteAssociationPayrateFulfilled(id: string) {
  return { type: types.PAYRATES_DELETE_ASSOCIATION_FULFILLED, payload: id };
}
function deleteAssociationPayrateRejected(error: Error) {
  return {
    type: types.PAYRATES_DELETE_ASSOCIATION_REJECTED,
    payload: { message: error.message, stack: error.stack },
  };
}

function getAssociationPayratesStarted() {
  return { type: types.PAYRATES_GET_ASSOCIATION_STARTED };
}
function getAssociationPayratesFulfilled(payrates: IPayRate[]) {
  return { type: types.PAYRATES_GET_ASSOCIATION_FULFILLED, payload: payrates };
}
function getAssociationPayratesRejected(error: Error) {
  return {
    type: types.PAYRATES_GET_ASSOCIATION_REJECTED,
    payload: { message: error.message, stack: error.stack },
  };
}

function clonePayrateStarted() {
  return { type: types.PAYRATES_CLONE_STARTED };
}
function clonePayrateFulfilled(payrate: IPayRate) {
  return { type: types.PAYRATES_CLONE_FULFILLED, payload: payrate };
}
function clonePayrateRejected(error: Error) {
  return {
    type: types.PAYRATES_CLONE_REJECTED,
    payload: { message: error.message, stack: error.stack },
  };
}

function attachPayrateStarted() {
  return { type: types.PAYRATES_ATTACH_STARTED };
}
function attachPayrateFulfilled(attachment: IPayrateAttachment) {
  return { type: types.PAYRATES_ATTACH_FULFILLED, payload: attachment };
}
function attachPayrateRejected(error: Error) {
  return {
    type: types.PAYRATES_ATTACH_REJECTED,
    payload: { message: error.message, stack: error.stack },
  };
}

function detachPayrateStarted() {
  return { type: types.PAYRATES_DETACH_STARTED };
}
function detachPayrateFulfilled(id: string) {
  return { type: types.PAYRATES_DETACH_FULFILLED, payload: id };
}
function detachPayrateRejected(error: Error) {
  return {
    type: types.PAYRATES_DETACH_REJECTED,
    payload: { message: error.message, stack: error.stack },
  };
}

// Existing action functions
export function getPayrateById(id: string) {
  return (dispatch: any) => {
    dispatch(getPayrateByIdStarted());
    return RatesApi.getById(id)
      .then((payrate) => dispatch(getPayrateByIdFulfilled(payrate)))
      .catch((er) => dispatch(getPayrateByIdRejected(er)));
  };
}

export function getAllPayrates() {
  return (dispatch: any) => {
    dispatch(getAllPayratesStarted());
    return RatesApi.getAll()
      .then((payrates) => dispatch(getAllPayratesFulfilled(payrates)))
      .catch((er) => dispatch(getAllPayratesRejected(er)));
  };
}

// New action functions
export function createAssociationPayrate(payrate: ICreateAssociationPayrateRequest) {
  return (dispatch: any) => {
    dispatch(createAssociationPayrateStarted());
    return RatesApi.createAssociationPayrate(payrate)
      .then((result) => dispatch(createAssociationPayrateFulfilled(result)))
      .catch((er) => dispatch(createAssociationPayrateRejected(er)));
  };
}

export function updateAssociationPayrateById(id: string, updates: Partial<ICreateAssociationPayrateRequest>) {
  return (dispatch: any) => {
    dispatch(updateAssociationPayrateStarted());
    return RatesApi.updateAssociationPayrateById(id, updates)
      .then((result) => dispatch(updateAssociationPayrateFulfilled(result)))
      .catch((er) => dispatch(updateAssociationPayrateRejected(er)));
  };
}

export function deleteAssociationPayrateById(id: string) {
  return (dispatch: any) => {
    dispatch(deleteAssociationPayrateStarted());
    return RatesApi.deleteAssociationPayrateById(id)
      .then(() => dispatch(deleteAssociationPayrateFulfilled(id)))
      .catch((er) => dispatch(deleteAssociationPayrateRejected(er)));
  };
}

export function getAssociationPayrates() {
  return (dispatch: any) => {
    dispatch(getAssociationPayratesStarted());
    return RatesApi.getAssociationPayrates()
      .then((payrates) => dispatch(getAssociationPayratesFulfilled(payrates)))
      .catch((er) => dispatch(getAssociationPayratesRejected(er)));
  };
}

export function clonePayrate(sourceId: string, cloneData: IClonePayrateRequest) {
  return (dispatch: any) => {
    dispatch(clonePayrateStarted());
    return RatesApi.clonePayrate(sourceId, cloneData)
      .then((result) => dispatch(clonePayrateFulfilled(result)))
      .catch((er) => dispatch(clonePayrateRejected(er)));
  };
}

export function attachPayrateToAssociation(attachment: ICreateAssociationPayrateAttachmentRequest) {
  return (dispatch: any) => {
    dispatch(attachPayrateStarted());
    return RatesApi.createAssociationPayrateAttachment(attachment)
      .then((result) => dispatch(attachPayrateFulfilled(result)))
      .catch((er) => dispatch(attachPayrateRejected(er)));
  };
}

export function detachPayrateFromAssociation(id: string) {
  return (dispatch: any) => {
    dispatch(detachPayrateStarted());
    return RatesApi.deleteAssociationPayrateAttachment(id)
      .then(() => dispatch(detachPayrateFulfilled(id)))
      .catch((er) => dispatch(detachPayrateRejected(er)));
  };
}
